export const baseUrl = process.env.REACT_APP_BASE_URL
  ? process.env.REACT_APP_BASE_URL
  : "https://apidev.uygunakirala.com/";
export const imageUrl =
  "https://uyguna-kirala-beta.s3.eu-central-1.amazonaws.com";
export const accountUrl = "api/admin/accounts";
export const productUrl = "api/admin/products";
export const addProductUrl = "api/product";
export const productRequestUrl = "api/admin/productrequests";
export const createUserUrl = "api/admin/accounts/create-account";
export const createDocumentUrl = "api/admin/accounts/add-account-documents";
export const documentsUrl = "/api/admin/accounts/get-account-document-types";
export const pendingProductsUrl = "api/admin/dashboard/get-pending-products";
export const getTicketsUrl = "api/admin/dashboard/get-open-tickets";
export const tickets = "api/tickets";
export const getCounts = "/api/admin/dashboard/get-counts";
export const ticketAnswer = "/api/tickets/get-ticket-answers";
export const productComments =
  "api/admin/dashboard/get-pending-product-comments";
export const adminContracts = "api/admin/admincontracts";
export const adminActiveContracts = "api/admin/admincontracts/get-actives";
export const adminPendingContracts = "api/admin/admincontracts/get-pendings";
export const adminClosedContracts = "api/admin/admincontracts/get-closed";
export const adminProducts = "/api/admin/products/get-account-products";
export const adminAddContract = "/api/admin/admincontracts/add-contract";
export const getUsersUrl = "api/admin/accounts/get-users";
export const getMobileScreenUrl = "api/admin/notifications/get-mobile-screens";
export const adminSendNotification = "api/admin/notifications";
export const adminSliderUrl = "api/admin/sliders";
export const adminCategories = "api/admin/categories";
export const pendingTicketsUrl = "/api/admin/dashboard/get-open-tickets";
export const adminAccountCallLogStatusUrl =
  "/api/admin/adminaccountcalllogstatuses";
export const adminAccountCallLogs = "/api/admin/adminaccountcalllogs";
export const adminBlogsUrl = "/api/admin/adminblogs";
export const adminPoliciesUrl = "/api/admin/adminpolicies";
export const adminSSSUrl = "/api/admin/adminfaqs";
export const adminProductFeturesUrl = "/api/admin/productfeatures";
export const adminEmailTemplatesUrl = "/api/admin/emailtemplates";
export const adminContactsUrl = "/api/admin/contacts";
export const contactUrl = "/api/contacts";
export const adminAccountCallUrl =
  "/api/admin/adminaccountcalllogs/get-by-account-id/";
export const adminAccountStorageUrl =
  "/api/admin/adminaccountstorages/get-by-account-id";
export const adminPackagesUrl = "/api/admin/adminpackages";
export const adminSystemPriceUrl = "/api/admin/systempackageprice";
export const adminPendingContacts = "/api/admin/dashboard/get-pending-contacts";
